module.exports = __webpack_public_path__ + "img/shop.0a081b43.png";